// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help-btn[data-v-3e1c75fc]{text-transform:none;font-size:14px}", ""]);
// Exports
module.exports = exports;
